/* istanbul ignore file */
import { array as codecArray } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { FileRuleInputData } from './FileRuleInputData';
import { OptionsInputData } from './OptionsInputData';
const SubmissionValidatorInputDataParser = 
/* #__PURE__ */ parsers.object([
    ['policy', /* #__PURE__ */ parsers.exactly('allow_all_files', 'deny_all_files')],
    ['rules', /* #__PURE__ */ codecArray(FileRuleInputData)],
    ['options', /* #__PURE__ */ codecArray(OptionsInputData)],
]);
export class SubmissionValidatorInputData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return SubmissionValidatorInputDataParser.decode(input).map(res => new SubmissionValidatorInputData(res));
    }
    static unsafeDecode(input) {
        return SubmissionValidatorInputData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return SubmissionValidatorInputDataParser.encode(data);
    }
    static schema() {
        return SubmissionValidatorInputDataParser.schema();
    }
}
